import React from 'react';

import { PageTitle, Reports } from '../../../components';



const ReportPage = () => {
 
  return ( 
    <>  
      {/* Page Title */}
      <PageTitle title={'Reports'} page={'Reports'} />

      {/* Reports Section */}
      <section>
        <Reports />
      </section>
    </>
  );
  
}

export default ReportPage;